import React from 'react';
import { X } from 'lucide-react';

/**
 * Modale generica per ospitare una `ClientAccountCards` card quando
 * l'azione viene invocata dal menu contestuale di `AdminClientsPage`
 * (richiesta utente 23/02/2026: "Nella lista mostra la modale con la
 * rispettiva card").
 */
export function ClientCardModal({
  open, onClose, children,
}: { open: boolean; onClose: () => void; children: React.ReactNode }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="client-card-modal">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative w-full max-w-sm mx-4">
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-10 w-7 h-7 rounded-full bg-white border shadow flex items-center justify-center text-muted-foreground hover:text-foreground"
          data-testid="client-card-modal-close"
        >
          <X className="w-3.5 h-3.5" />
        </button>
        {children}
      </div>
    </div>
  );
}
